module.exports = __webpack_public_path__ + "img/dsjksh.69b01d62.png";